import { Checkbox, Input, Popover, Select } from 'antd'
import { useState } from 'react'
import styles from './index.module.scss'

const PREVIEW_IMAGE_PREFIX = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/smart-detail-page/'

const DETAIL_CONFIG_PREVIEW_MAP = {
    poster: { title: '电商首屏海报', image: `${PREVIEW_IMAGE_PREFIX}detail_config1.png` },
    sellingPoint: { title: '商品卖点介绍', image: `${PREVIEW_IMAGE_PREFIX}detail_config2.png` },
    buyerShow: { title: '商品痛点解决', image: `${PREVIEW_IMAGE_PREFIX}detail_config3.png` },
    sceneStyling: { title: '还原穿搭场景', image: `${PREVIEW_IMAGE_PREFIX}detail_config4.png` },
    productInfo: { title: '详细产品信息', image: `${PREVIEW_IMAGE_PREFIX}detail_config5.png` },
    productDetail: { title: '商品细节放大', image: `${PREVIEW_IMAGE_PREFIX}detail_config6.png` },
    sizeChart: { title: '商品尺码表', image: `${PREVIEW_IMAGE_PREFIX}detail_config7.png` },
    serviceGuarantee: { title: '购物保障说明', image: `${PREVIEW_IMAGE_PREFIX}detail_config8.png` },
}

export const INITIAL_SMART_DETAIL_ITEMS = [
    { key: 'poster', label: '首屏海报', value: 1, fixed: true, enabled: true },
    { key: 'sellingPoint', label: '产品卖点', value: 1, enabled: true, required: true },
    { key: 'buyerShow', label: '痛点解决', value: 1, enabled: true },
    { key: 'sceneStyling', label: '场景化穿搭', value: 1, enabled: true },
    { key: 'productInfo', label: '产品信息', value: 1, enabled: true },
    { key: 'productDetail', label: '产品细节', value: 2, enabled: true },
    { key: 'sizeChart', label: '尺码表', value: 1, enabled: true },
    // 暂时隐藏“模特图 / 智能模式 / 设置模特”
    // { key: 'modelImage', label: '模特图', value: 1, enabled: true, showModeRow: true },
    { key: 'serviceGuarantee', label: '购物保障', value: 1, enabled: true },
]

export const getSmartDetailImageCount = (itemList = []) => {
    return itemList.reduce((sum, item) => {
        if (item.fixed || item.enabled) return sum + (item.value || 0)
        return sum
    }, 0)
}

const countOptions = Array.from({ length: 8 }, (_, index) => index + 1).map((value) => ({
    label: `${value}张`,
    value,
}))

const SmartDetailPageConfigBar = ({ itemList: itemListProp, onChange }) => {
    const [innerItemList, setInnerItemList] = useState(INITIAL_SMART_DETAIL_ITEMS)
    const itemList = itemListProp || innerItemList
    const setItemList = onChange || setInnerItemList

    const updateItem = (key, patch) => {
        setItemList((prev) => prev.map((item) => item.key === key ? { ...item, ...patch } : item))
    }

    return (
        <div className={styles.root}>
            <div className={styles.titleWrap}>
                <span className={styles.title}>详情页内容配置</span>
                <span className={styles.titleDesc}>未选择参考图的任务按配置生成；已选择参考详情图的任务依据参考详情图分析结果生成</span>
            </div>
            <div className={styles.groupList}>
                {itemList.map((item) => {
                    const previewConfig = DETAIL_CONFIG_PREVIEW_MAP[item.key]
                    const triggerNode = item.fixed || item.required ? (
                        <span className={styles.labelTrigger}>
                            <span className={styles.label}>{item.label}</span>
                        </span>
                    ) : (
                        <span className={styles.labelTrigger}>
                            <Checkbox
                                checked={item.enabled}
                                onChange={(e) => updateItem(item.key, { enabled: e.target.checked })}
                            >
                                <span className={styles.label}>{item.label}</span>
                            </Checkbox>
                        </span>
                    )

                    const labelContent = previewConfig ? (
                        <Popover
                            trigger="hover"
                            placement="top"
                            overlayClassName={styles.ConfigPreviewPopover}
                            content={(
                                <div className={styles.PreviewCard}>
                                    <img className={styles.PreviewImage} src={previewConfig.image} alt={previewConfig.title} />
                                    <p className={styles.PreviewTitle}>{previewConfig.title}</p>
                                </div>
                            )}
                        >
                            {triggerNode}
                        </Popover>
                    ) : triggerNode

                    return (
                        <div className={styles.group} key={item.key}>
                            {labelContent}
                            {item.fixed ? (
                                <Popover
                                    trigger="hover"
                                    placement="top"
                                    overlayClassName={styles.PosterInputPopover}
                                    content={<div className={styles.PosterInputTips}>仅支持生成1张</div>}
                                >
                                    <Input
                                        className={`${styles.input} ${styles.posterInput}`}
                                        value={item.value}
                                        readOnly
                                    />
                                </Popover>
                            ) : (
                                <Select
                                    className={`${styles.select} ${!item.enabled ? styles.selectDisabled : ''}`}
                                    options={countOptions}
                                    value={item.value}
                                    disabled={!item.enabled}
                                    onChange={(value) => updateItem(item.key, { value })}
                                />
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default SmartDetailPageConfigBar
